import React from "react";
import Flex from "./layouts/Flex";
import { optionallyRenderIcon } from "./renderIcon";
import { SPACING_SMALL } from "./theme";
const Badge = ({ icon, iconSize, label }) => (React.createElement(Flex, { inline: true, alignItems: "center", gap: SPACING_SMALL },
    optionallyRenderIcon(icon, { fontSize: iconSize }),
    React.createElement("span", null, label)));
export default Badge;
//# sourceMappingURL=Badge.js.map